import Legal from "../Legal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { getPackageName } from "../../../Shared/common";
import Typography from '@material-ui/core/Typography';
import React from "react";

function Package({code, name, checked, onClick, onComplete, nofloorPlanChecked, floorPlanChecked, floorPlanClicked, nofloorPlanClicked}) {
    const legal =
        checked
            ? <Legal
                style={{color: 'white'}}
                code={code}
                floorPlanChecked={floorPlanChecked}
                nofloorPlanChecked={nofloorPlanChecked}
                onFloorPlanCheck={floorPlanClicked}
                onNoFloorPlanCheck={nofloorPlanClicked}
                pack={code}
                onComplete={onComplete}/>
            : null;
    return (
        <div>
            <FormControlLabel
                style={{color: 'white'}}
                control={
                    <Checkbox
                        style={{color: 'white'}}
                        checked={checked}
                        onChange={onClick}
                        value={`${code}_${name}`}
                        id={code}
                        className={"package-available"}
                    />
                }
                label={<Typography style={{ color: 'white' }}>{getPackageName(code)}</Typography>}
            />
            {legal}
        </div>
    )
}

export default Package;